import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    label: 'Task Details',
    value: 'task-details',
    path: '/my-task/question-creation/:taskId/details',
  },
  {
    label: 'Question List',
    value: 'question-list',
    path: '/my-task/question-creation/:taskId/question-list',
  },
];

export default function MyTaskNavigationTabs() {
  return <NavigationTabs items={TAB_ITEMS} navigateOptions={{ replace: true }} />;
}
